"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f8217 = void 0;
exports.f8217 = {
    "’aeke": [
        121
    ],
    "’aqwalazul": [
        252
    ],
    "’are’are": [
        277
    ],
    "’aragure": [
        571
    ],
    "’unar": [
        732
    ],
    "’bidio": [
        839
    ],
    "’bidiyo": [
        839
    ],
    "’beli": [
        923
    ],
    "’bëlї": [
        923
    ],
    "’táy": [
        933,
        934,
        935
    ],
    "’ôrôê": [
        1034
    ],
    "’ba": [
        1171
    ],
    "’yara": [
        1401
    ],
    "’di’dinga": [
        1848
    ],
    "’olelo hawai’i": [
        2907
    ],
    "’olelo": [
        2907
    ],
    "’olelo hawai’i makuahine": [
        2907
    ],
    "’aforit": [
        3063
    ],
    "’aveke": [
        3098
    ],
    "’auhelawa": [
        4017
    ],
    "’urada": [
        4017
    ],
    "’dem": [
        4079
    ],
    "’lobiir": [
        4441
    ],
    "’lobiiri": [
        4441
    ],
    "’moaeke": [
        4865
    ],
    "’am’akhav": [
        4978
    ],
    "’eo ’enata": [
        5021
    ],
    "’eo": [
        5021,
        5057
    ],
    "’enata": [
        5021
    ],
    "’moaveke": [
        5050
    ],
    "’eo ’enana": [
        5057
    ],
    "’enana": [
        5057
    ],
    "’weenhayeklhayhi’": [
        5116
    ],
    "’weenhayeklhàmet": [
        5116
    ],
    "’an xo’boó": [
        6051
    ],
    "’an": [
        6051
    ],
    "’balo": [
        6052
    ],
    "’ajnabi": [
        6212
    ],
    "’āirani": [
        6472
    ],
    "’gana": [
        7808
    ],
    "’iduh": [
        7863
    ],
    "’uuk-umpithamu": [
        7959
    ],
    "’abotee": [
        8145
    ],
    "’abwetee": [
        8145
    ]
};
